import { constant, min, size, times } from "lodash";
import { transparentize } from "@glossy";

function getPolarizedData(data: number[]): number[] {
  const polarizedData = data.map((d: number) => d / 100);
  return polarizedData;
}

export function getFormatedData(
  data: number[],
  color: string,
  polarizeColors: boolean
) {
  const _data = polarizeColors ? getPolarizedData(data) : data;
  const minValue = polarizeColors ? 0 : min(data);
  return {
    labels: Array.from({ length: _data.length }).map((_, i) => i.toString()),
    datasets: [
      {
        data: _data,
        fill: true,
        backgroundColor: transparentize(0.95, color),
        borderColor: color,
        borderWidth: 2,
        radius: 0,
        tension: 0,
      },
      {
        data: times(size(_data), constant(minValue)),
        backgroundColor: "transparent",
        borderColor: "transparent",
        borderWidth: 0,
        radius: 0,
        tension: 0,
      },
    ],
  };
}
